<block-ui [template]="blockTemplate">
    <div class="contenedor loteriadia__cards">
        <!-- COM Loteria -->
        <div class="loteriadia__card">
            <mat-card class="example-card">
                <mat-card-content class=" loteriadia__contenedorInfo">
                    <div class="loteriadia__contenedorIcono" *ngIf="resize >= 768">
                        <img src="../../../../assets/imagenes/icons/detalle_sucursales/loterias.svg" alt="Logo loterias">
                    </div>
                    <div class="loteriadia__infoCard">
                        <h5 class="loteriadia__labelCard">Loter&#237;a</h5>
                        <p class="loteriadia__valor">RD{{totalesCardDetalleSucursales?.totalLoteria | currency}}</p>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- COM Premios -->
        <div class="loteriadia__card">
            <mat-card class="example-card">
                <mat-card-content class=" loteriadia__contenedorInfo">
                    <div class="loteriadia__contenedorIcono" *ngIf="resize >= 768">
                        <img src="../../../../assets/imagenes/icons/detalle_sucursales/premios.svg" alt="Logo premios">
                    </div>
                    <div class="loteriadia__infoCard">
                        <h5 class="loteriadia__labelCard">Premios</h5>
                        <p class="loteriadia__valor">RD{{totalesCardDetalleSucursales?.totalPremios | currency}}</p>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- COM Neto Loteria -->
        <div class="loteriadia__card">
            <mat-card class="example-card">
                <mat-card-content class=" loteriadia__contenedorInfo">
                    <div class="loteriadia__contenedorIcono" *ngIf="resize >= 768">
                        <img src="../../../../assets/imagenes/icons/detalle_sucursales/neto_loteria.svg" alt="Logo neto loteria">
                    </div>
                    <div class="loteriadia__infoCard">
                        <h5 class="loteriadia__labelCard">Neto Loter&#237;a</h5>
                        <p class="loteriadia__valor loteriadia__valor--negativo perdida" *ngIf="totalesCardDetalleSucursales?.totalNetoLoteria < 0">RD{{totalesCardDetalleSucursales?.totalNetoLoteria | currency}}</p>
                        <p class="loteriadia__valor" *ngIf="totalesCardDetalleSucursales?.totalNetoLoteria >= 0" [ngClass]="totalesCardDetalleSucursales?.totalNetoLoteria > resultado ? 'ganancia' : ''">RD{{totalesCardDetalleSucursales?.totalNetoLoteria | currency}}</p>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- COM Otros Productos -->
        <div class="loteriadia__card" (click)="abrirModalOtrosProductos()">
            <mat-card class="example-card">
                <mat-card-content class=" loteriadia__contenedorInfo">
                    <div class="loteriadia__contenedorIcono" *ngIf="resize >= 768">
                        <img src="../../../../assets/imagenes/icons/detalle_sucursales/otros_productos.svg" alt="Logo otros">
                    </div>
                    <div class="loteriadia__infoCard">
                        <h5 class="loteriadia__labelCard">Otros Productos</h5>
                        <p class="loteriadia__valor">RD{{totalesCardDetalleSucursales?.totalVentas | currency}}</p>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- COM Resultado Final -->
        <div class="loteriadia__card">
            <mat-card class="example-card">
                <mat-card-content class=" loteriadia__contenedorInfo">
                    <div class="loteriadia__contenedorIcono" *ngIf="resize >= 768">
                        <img src="../../../../assets/imagenes/icons/detalle_sucursales/resultado_final.svg" alt="Logo resultado">
                    </div>
                    <div class="loteriadia__infoCard">
                        <h5 class="loteriadia__labelCard">Resultado Final</h5>
                        <p class="loteriadia__valor loteriadia__valor--negativo perdida" *ngIf="totalesCardDetalleSucursales?.totalResultadoFinal < 0">RD{{totalesCardDetalleSucursales?.totalResultadoFinal | currency}}</p>
                        <p class="loteriadia__valor" *ngIf="totalesCardDetalleSucursales?.totalResultadoFinal >= 0">RD{{totalesCardDetalleSucursales?.totalResultadoFinal | currency}}</p>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- COM Balance Otros Productos -->
        <div class="loteriadia__card" (click)="abrirModalBalanceOtrosProductos()">
            <mat-card class="example-card">
                <mat-card-content class=" loteriadia__contenedorInfo">
                    <div class="loteriadia__contenedorIcono" *ngIf="resize >= 768">
                        <img src="../../../../assets/imagenes/icons/detalle_sucursales/balance.svg" alt="Logo balance">
                    </div>
                    <div class="loteriadia__infoCard">
                        <h5 class="loteriadia__labelCard--textLarge">Balance Otros Productos</h5>
                        <p class="loteriadia__valor loteriadia__valor--negativo perdida" *ngIf="totalesCardDetalleSucursales?.totalRecarga < 0">RD{{totalesCardDetalleSucursales?.totalRecarga | currency}}</p>
                        <p class="loteriadia__valor" *ngIf="totalesCardDetalleSucursales?.totalRecarga >= 0">RD{{totalesCardDetalleSucursales?.totalRecarga | currency}}</p>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</block-ui>


<!-- COM: Modal ********************* -->


<ng-template #modalOtrosProductos>
    <app-modal-general>
        <div body>
            <div class="modal__contenedorTitulo">
                <h2 class="modal__label">Otros Productos</h2>
            </div>
            <div class="modal__body">
                <app-tabla-otros-productos></app-tabla-otros-productos>
            </div>
        </div>
    </app-modal-general>
</ng-template>

<ng-template #modalBalanceOtrosProductos>
    <app-modal-general>
        <div body>
            <div class="modal__contenedorTituloBalance">
                <h2 class="modal__label">Balance Otros Productos Empresas</h2>
            </div>
            <div class="modal__body">
                <app-tabla-balance-otros-productos-empresas></app-tabla-balance-otros-productos-empresas>
            </div>
            <div class="modal__contenedorTituloResumenBalance" *ngIf="visualizarResumen">
                <h2 class="modal__label">Resumen Balance Otros Productos</h2>
            </div>
            <div class="modal__resumen" *ngIf="visualizarResumen">
                <app-balance-otros-productos></app-balance-otros-productos>
            </div>

        </div>
    </app-modal-general>
</ng-template>